// @ts-ignore
import { getValues, createCustomValue, deleteCustomValue } from "api";
import Notify from "utils/notify";

import { ActionTypes } from "./types";

export const GetValues = (roles = []) => async (dispatch: any) => {
  try {
    dispatch({ type: ActionTypes.LOADING });

    // Create an array of promises for each role
    const promises = roles.map((role) => getValues({ role_id: role }));

    // Await all promises to resolve
    const results = await Promise.all([...promises, getValues({ custom: true })]);

    // Combine all data from results
    const combinedData = results.flatMap((result: any) => result.data);
    
    // Use a Map to remove duplicates by item.id
    const uniqueDataMap = new Map();
    combinedData.forEach((item: any) => {
      if (item?.id) {
        uniqueDataMap.set(item.id, item);
      }
    });
    
    // Map the unique data to the desired format
    const formattedData = Array.from(uniqueDataMap.values()).map((item: any) => ({
      label: item?.name,
      value: item?.id,
      custom: item?.custom && item?.custom_user
    }));

    dispatch({
      type: ActionTypes.SUCCESS,
      payload: formattedData,
    });
  } catch (error) {
    Notify.error(error, true);

    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};

export const CreateCustomValue = (formData: FormData, callback?: (element: any) => void) => async (dispatch: any) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data } = await createCustomValue(formData);

    const customItem = {
      label: data.name,
      value: data.id,
      custom: data.custom && data.custom_user
    }

    dispatch({
      type: ActionTypes.CREATE_CUSTOM_SUCCESS,
      payload: customItem
    });

    if (callback) {
      callback(customItem);
    }

    Notify.success("Custom Value created successfully.");
  } catch (error) {
    Notify.error(error, true);

    dispatch({
      type: ActionTypes.ERROR,
      payload: error
    });
  }
};

export const DeleteCustomValue = (id: string) => async (dispatch: any) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    await deleteCustomValue(id);

    dispatch({
      type: ActionTypes.DELETE_CUSTOM_SUCCESS,
      payload: id
    });

    Notify.success("Custom Value deleted successfully.");
  } catch (error) {
    Notify.error(error, true);

    dispatch({
      type: ActionTypes.ERROR,
      payload: error
    });
  }
};

